export const CARTO_TOKEN =
  "eyJhbGciOiJIUzI1NiJ9.eyJhIjoiYWNfa2M2cTAzbGUiLCJqdGkiOiJkYjkzZjU2MSJ9.jCl8mEyX7nhsfQZsbHmlKnzX_IS_YngMn7Ez2nL3cxI";
export const CARTO_API =
  "https://gcp-europe-west1.api.carto.com/v3/sql/carto_dw/query";

export const CARTO_BASEMAP_KEY = "cb1_2pyz_1_10a015b248121012f4dcd3e1";

export const cartoBasemapUrl = (subdomain = "{s}") =>
  `https://${subdomain}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=${CARTO_BASEMAP_KEY}`;
export const cartoBasemapTileUrl = (subdomain: string, zoom: number, x: number, y: number) =>
  `https://${subdomain}.basemaps.cartocdn.com/dark_all/${zoom}/${x}/${y}.png?key=${CARTO_BASEMAP_KEY}`;


// ─── TABLES ───────────────────────────────────────────────────

export const TABLE_ISO = "carto-dw-ac-kc6q03le.shared.India_IGO_iso_time_optimized";
export const TABLE_POP = "carto-dw-ac-kc6q03le.shared.India_Population_ByTime";
export const TABLE_MOBILITY = "carto-dw-ac-kc6q03le.shared.india_hexTable_052025_short";

// ─── INTERFACES ──────────────────────────────────────────────

export interface MetroOrigin {
  metro_origin: string;
  lat: number;
  lng: number;
}

// ─── CONSTANTES ──────────────────────────────────────────────

export const AIRPORT_TYPES = [
  "Scheduled operations",
  "Potential location",
  "Unscheduled operations",
  "Under construction",
  "Construction plan",
];

export const TIME_OPTIONS = [30, 60, 90, 120, 150, 180];

export const COLORS: Record<string, string> = {
  "Scheduled operations": "#009A84",
  "Potential location": "#56C177",
  "Unscheduled operations": "#99D6EA",
  "Under construction": "#EB280F",
  "Construction plan": "#00313C",
};

// ─── COULEURS ATR ────────────────────────────────────────────

export const ATR_COLORS = {
  newMoon: "#00313C",
  turquoise: "#009A84",
  green: "#56C177",
  lightBlue: "#99D6EA",
  red: "#EB280F",
};

export const ATR_GRADIENT = `linear-gradient(135deg, ${ATR_COLORS.turquoise} 0%, ${ATR_COLORS.green} 50%, ${ATR_COLORS.lightBlue} 100%)`;